interface IArrowProps {
  direction?: string;
  className?: string;
  fill?: string;
  type?: 'default' | 'large';
  onClick?: () => void;
}

const directionMap = {
  left: 'rotate(0)',
  down: 'rotate(-90deg)',
  right: 'rotate(-180deg)',
  up: 'rotate(-270deg)',
};

const getDirection = (direction: string) => directionMap[direction] || 'rotate(0)';

export const Arrow = ({
  className,
  fill = 'black',
  direction = 'up',
  type = 'default',
  onClick,
}: IArrowProps) => {
  // LARGE ARROW
  if (type === 'large') {
    return (
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
        style={{ transform: getDirection(direction) }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64646 0.646477L0.646462 6.64648L0.292908 7.00003L0.646462 7.35358L6.64646 13.3536L7.35357 12.6465L2.20712 7.50003H17V6.50003H2.20712L7.35357 1.35358L6.64646 0.646477Z"
          fill={fill}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="8"
      viewBox="0 0 29 8"
      fill="black"
      className={className}
      onClick={onClick}
      style={{ transform: getDirection(direction) }}
    >
      <g>
        <path
          d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35356L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17158C4.7308 0.976313 4.7308 0.65973 4.53553 0.464468C4.34027 0.269206 4.02369 0.269206 3.82843 0.464468L0.646446 3.64645ZM29 3.5L1 3.5L1 4.5L29 4.5L29 3.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
